import { apiClient } from '../../api/client';
import { ApiResponse } from '../../api/types';
import { BotFillConfig, BotFillStage } from './types';
const URL = '/api/v1/admin/bot-fill-config';
export async function getBotFillConfig(stage: BotFillStage): Promise<BotFillConfig> {
  return (await apiClient.get<ApiResponse<BotFillConfig>>(`${URL}/${stage}`)).data.data;
}
export async function saveBotFillConfig(stage: BotFillStage, input: BotFillConfig): Promise<BotFillConfig> {
  return (await apiClient.put<ApiResponse<BotFillConfig>>(`${URL}/${stage}`, input)).data.data;
}
